
    import { Component, Inject} from 'ng-metadata/core';
    import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';
    import {SearchFieldsService} from '../../search.fields.service';
    import {FacetService} from '../../facet/facet.service';
    import {PrimolyticsService,beacon} from '../../../analytics/primolytics.service';
    import {NewspapersService} from '../../../newspapers/newspapers.service';



    @Component({
            "selector": "prm-search-result-sort-by",
            templateUrl: 'components/search/searchResult/searchResultSortBy/searchResultSortBy.html'
        })


     export class SearchResultSortBy{
        private myOptions:any;

        constructor(private configurationUtil: ConfigurationUtil,
                    private searchFieldsService: SearchFieldsService,
                    private facetService: FacetService, private primolyticsService:PrimolyticsService,
                    @Inject('$stateParams')  private $stateParams:ng.ui.IStateParamsService,
                    private newspapersService: NewspapersService) {

            this.myOptions = this.configurationUtil
                .getBriefResultConfiguration()
                .sortby.split(',')
                .filter((value, index, arr)=> {
                    return value !== 'popularity'
                })
                .map(this.createSortByMapping);

            if (this.newspapersService.isNewspapersSearch()) {
                this.myOptions = this.myOptions.filter((sort) => {
                    return ['rank', 'date','date_d', 'date_a', 'date2'].indexOf(sort.value) !== -1;
                });
            }

            let journalOrDatabasesValue = this.$stateParams['journals'] || this.$stateParams['databases']; // can't be both in the same time
            if (journalOrDatabasesValue) {
                this.myOptions = [];
                if (journalOrDatabasesValue.split(",")[0] === 'any') {
                    this.myOptions.push(this.createSortByMapping('rank'));
                    this.myOptions.push(this.createSortByMapping('title'));
                }
            }

            if (!this.sortBy) {
                this.sortBy = this.myOptions[0].value; //init sort by
            }
        }

         /* getters & setters */
        get options() {
             return this.myOptions;
        };

        @beacon({'p':'sort'})
        get sortBy() {
            return this.searchFieldsService.sortby;
        };

        set sortBy(sortBy) {
            this.searchFieldsService.sortby = sortBy;
        };



        private createSortByMapping(e) {
            return {
                value:e,
                text: e
            };

        }

        private onSortChange(){
            this.facetService.facetSearch({sortby: this.sortBy, came_from:'sort'});
        }

     }




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultSortBy/searchResultSortBy.directive.ts